import { showModal } from './modal';

$('.btn-modal-accept-contact').on('click', function (evt) {
    evt.stopPropagation();
    evt.preventDefault();
    showModal('modal-accept-contact');
});

$('.btn-modal-accept-press').on('click', function (evt) {
    evt.stopPropagation();
    evt.preventDefault();
    showModal('modal-accept-press');
});

$('.btn-modal-accept-newsletter').on('click', function (evt) {
    evt.stopPropagation();
    evt.preventDefault();
    showModal('modal-accept-newsletter');
});

$(window).on('load', function (evt) {
    evt.stopPropagation();
    evt.preventDefault();
    showModal('modal-accept-warning');
});

$(window).on('load', function (evt) {
    evt.stopPropagation();
    evt.preventDefault();
    showModal('modal-sucess-consent');
});
